import { render, staticRenderFns } from "./Decoration6.vue?vue&type=template&id=121aa518&scoped=true"
import script from "./Decoration6.vue?vue&type=script&lang=js"
export * from "./Decoration6.vue?vue&type=script&lang=js"
import style0 from "./Decoration6.vue?vue&type=style&index=0&id=121aa518&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121aa518",
  null
  
)

export default component.exports